import { AffiliateProgramPaypalInterface } from 'modules/profile/affiliate-program-settings/components/affiliate-program-paypal'
import {
  AffiliateProgramLinkCreateInterface,
  AffiliateProgramSettingsInterface,
} from 'modules/profile/affiliate-program-settings/types/affiliate-program-settings-interface'
import httpClient from 'shared/utils/http-client'

export const AFFILIATE_PROGRAM_SETTINGS_API = '/api/dashboard/customer/settings/affiliate-program'

export const saveAffiliateProgram = (data: AffiliateProgramSettingsInterface) =>
  httpClient.put<AffiliateProgramSettingsInterface>(
    `${AFFILIATE_PROGRAM_SETTINGS_API}/program`,
    data,
  )

export const addPaypal = (data: AffiliateProgramPaypalInterface) =>
  httpClient.post(`${AFFILIATE_PROGRAM_SETTINGS_API}/pay-pal-create`, data)

export const deletePaypal = () =>
  httpClient.post(`${AFFILIATE_PROGRAM_SETTINGS_API}/pay-pal-remove`)

export const deleteWise = () => httpClient.delete(`/dashboard/profile/transfer-wise/account/remove`)

export const deleteLink = (id: number) =>
  httpClient.delete(`${AFFILIATE_PROGRAM_SETTINGS_API}/links/${id}`)

export const createLink = (data: AffiliateProgramLinkCreateInterface) =>
  httpClient.post(`${AFFILIATE_PROGRAM_SETTINGS_API}/links`, data)
